import { Spin } from 'antd'
import React from 'react'

const Loader = ({ className = '' }: { className?: string }) => {
  return (
    <div
      className={`loading_wrapper  loading-${
        process.env.REACT_APP_COLOR === 'hitron'
          ? 'hitron'
          : process.env.REACT_APP_COLOR === 'customer'
          ? 'customer'
          : process.env.REACT_APP_COLOR === 'entpnt'
          ? 'entpnt'
          : 'local'
      }-wrapper ${className}`}
    >
      <Spin
        tip='Loading'
        style={{
          color:
            process.env.REACT_APP_COLOR === 'hitron'
              ? '#004C97'
              : process.env.REACT_APP_COLOR === 'customer'
              ? '#ff974c'
              : process.env.REACT_APP_COLOR === 'entpnt'
              ? '#45546A'
              : '#FF8181'
        }}
      >
        <div className='content' />
      </Spin>
    </div>
  )
}

export default Loader
